module.exports = __webpack_public_path__ + "img/图片29.fa1990e0.png";